module.exports = __webpack_public_path__ + "img/tech__panel.d8737279.svg";